import { LOGIN_SIGNUP_METHODS } from "enums";

export const isMethodValid = (method) => {
  return Object.values(LOGIN_SIGNUP_METHODS).includes(method);
};
